import type { SupplierRow } from './SupplierList.types'

export function mapApiDataToRows(data: SupplierRow[]): SupplierRow[] {
  return data.map(s => ({
    ...s,
    documentsUrl: s.documentsUrl ?? '',
  }))
}
